import {ChangeDetectorRef, Component, ElementRef, NgZone, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UserAuthService} from '../../../@core/user-auth.service';
import {UnsubscribeComponent} from '../../../@core/fc-component';
import {RequestHandler} from '../../../@core/utils/request-handler';
import {from, Subject} from 'rxjs';
import {ConfigService} from '../../../@core/config.service';
import {SSOService} from '../../../@core/sso.service';
import {takeUntil} from 'rxjs/operators';
import {JWTService} from '../../../@core/jwt.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent extends UnsubscribeComponent implements OnInit {
    @ViewChild('tempRefPw') templateRefPw: ElementRef;
    @ViewChild('tempRefU') tempRefU: ElementRef;
    _ua: any;

    email: string;
    password: string;
    messages: any;
    loginRequest = new RequestHandler(
        (email, password) => from(this.userAuthService.login(email, password)),
        {
            showErrorToast: false,
            destroy$: this.destroy$,
        }
    );
    authAfterSsoInProgress = false;

    private _queryParams = this.activatedRoute.snapshot.queryParams;
    private _cancelSso$ = new Subject<void>();

    constructor(public configService: ConfigService,
                private userAuthService: UserAuthService,
                private jwtService: JWTService,
                private ssoService: SSOService,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                private zone: NgZone,
                private ref: ChangeDetectorRef) {
        super();
    }

    ngOnInit(): void {
        this._ua = navigator.userAgent.toLowerCase();
        if (this._queryParams?.email) {
            this.email = this._queryParams.email;
        }
    }

    onSSOLogin() {
        this._cancelSso$.next();
        this.ssoService.openSSOLogin().pipe(takeUntil(this.destroy$), takeUntil(this._cancelSso$)).subscribe({
            next: res => {
                if (res.success) {
                    this.jwtService.setToken(res.token, res.refresh_token, false);
                    this.authAfterSsoInProgress = true;
                    this.userAuthService.updateUserInfo()
                        .then(() => this.navigateToLanding())
                        .catch(err => this.extractErrorMessages(err))
                        .finally(() => this.authAfterSsoInProgress = false);
                } else {
                    this.extractErrorMessages(res.error);
                }
            },
            error: err => this.extractErrorMessages(err),
        });
    }

    onSubmit(): void {
        delete this.messages;
        if (this._ua.includes('crios') && !this.email && !this.password) {
            this.password = this.templateRefPw.nativeElement.value;
            this.email = this.tempRefU.nativeElement.value;
        }
        this.loginRequest.call(this.email, this.password).subscribe(() => {
            if (this._queryParams.client_id) {
                this.router.navigate(['application-permission'], {queryParams: this._queryParams});
            } else {
                this.navigateToLanding();
            }
        }, error => {
            this.extractErrorMessages(error);
        });
    }

    navigateToLanding() {
        this.zone.run(() => {
            const {target, ...queryParams} = this.activatedRoute.snapshot.queryParams;
            this.router.navigate([target || '/'], {queryParams}).then();
        });
    }

    extractErrorMessages(error) {
        this.messages = typeof error === 'string' ?
            {non_field_errors: [error]} :
            error.non_field_errors || error.email || error.password ?
                error :
                {non_field_errors: ['An error occurred while trying to log in. Please try logging in later.']};
    }

    requestNewPassword() {
        this.router.navigate(['request-password'], {queryParams: {email: this._queryParams.email || this.email}});
    }

    ngOnDestroy() {
        this._cancelSso$.complete();
    }
}
